import React from 'react';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message }) => {
    if (!isOpen) {
        return null;
    }

    const styles = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
        },
        modal: {
            backgroundColor: 'white',
            padding: '2rem',
            borderRadius: '8px',
            boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
            maxWidth: '500px',
            width: '90%',
            textAlign: 'right',
            direction: 'rtl',
        },
        title: {
            marginTop: 0,
            color: '#333',
        },
        message: {
            color: '#555',
            marginBottom: '2rem',
        },
        buttonContainer: {
            display: 'flex',
            justifyContent: 'flex-start',
            gap: '1rem',
        },
        confirmButton: {
            backgroundColor: '#dc3545', // Red for delete
            color: 'white',
            border: 'none',
            padding: '0.75rem 1.5rem',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '1rem',
        },
        cancelButton: {
            backgroundColor: '#6c757d', // Gray
            color: 'white',
            border: 'none',
            padding: '0.75rem 1.5rem',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '1rem',
        },
    };

    return (
        <div style={styles.overlay} onClick={onClose}>
            <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                <h2 style={styles.title}>{title}</h2>
                <p style={styles.message}>{message}</p>
                <div style={styles.buttonContainer}>
                    <button style={styles.cancelButton} onClick={onClose}>
                        انصراف
                    </button>
                    <button style={styles.confirmButton} onClick={onConfirm}>
                        تایید و حذف
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;